/* Hoodsly global scripts — loaded on every page from layout/theme.liquid. */
(function () {
  'use strict';

  /* ── Header nav dropdown indicator ──
     Keeps .is-open (and aria-expanded) in sync on every li.hs-nav-dropdown
     in hs-main-header, hs-wholesale-header and hs-warehouse-header, so the
     chevron styles in common.css can show the open state.
     - Main header: the theme opens/closes a <details>; we mirror its toggle.
     - Wholesale / warehouse headers: CSS hover menus; we follow hover + focus. */
  function setOpen(item, open) {
    item.classList.toggle('is-open', open);
    var trigger = item.querySelector('.hs-nav-dropdown__trigger');
    if (trigger && trigger.tagName !== 'SUMMARY') {
      trigger.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
  }

  function bindNavDropdown(item) {
    if (item.dataset.hsNavDropdown) return;
    item.dataset.hsNavDropdown = 'bound';

    var details = item.querySelector('details');
    if (details) {
      details.addEventListener('toggle', function () {
        setOpen(item, details.open);
      });
      setOpen(item, details.open);
      return;
    }

    item.addEventListener('mouseenter', function () {
      setOpen(item, true);
    });
    item.addEventListener('mouseleave', function () {
      if (!item.contains(document.activeElement)) setOpen(item, false);
    });
    item.addEventListener('focusin', function () {
      setOpen(item, true);
    });
    item.addEventListener('focusout', function (event) {
      if (!item.contains(event.relatedTarget) && !item.matches(':hover')) {
        setOpen(item, false);
      }
    });
  }

  function initNavDropdowns(root) {
    (root || document).querySelectorAll('.hs-nav-dropdown').forEach(bindNavDropdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initNavDropdowns();
    });
  } else {
    initNavDropdowns();
  }

  /* Re-bind when a header is re-rendered in the theme editor. */
  document.addEventListener('shopify:section:load', function (event) {
    initNavDropdowns(event.target);
  });
})();
